import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatPostalCode' })
export class FormatPostalCodePipe implements PipeTransform {
  transform(postalCode: string): string {
    if (!postalCode) {
      return '';
    }
    postalCode = postalCode.toUpperCase();
    const postalCodeRegex = new RegExp('[A-Z][0-9][A-Z][0-9][A-Z][0-9]');

    // Remove all the spaces if there is any
    postalCode = postalCode.replace(/\s/g, "");

    // Only one space in the middle and it is applied if the postal code is in correct format A1B2C3 otherwise just return the postal code
    if (postalCodeRegex.test(postalCode))
      return postalCode.slice(0, 3) + ' ' + postalCode.slice(3);
    else
        return postalCode;
  }
}
